import { motion } from 'framer-motion'
import './PageHeader.css'

interface PageHeaderProps {
  eyebrow: string
  title: string
  lede?: string
}

const PageHeader = ({ eyebrow, title, lede }: PageHeaderProps) => {
  return (
    <header className="page-header">
      <motion.div
        className="page-header-inner"
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <span className="eyebrow">{eyebrow}</span>
        <h1>{title}</h1>
        {lede && <p>{lede}</p>}
      </motion.div>
    </header>
  )
}

export default PageHeader
